import { apiGet } from '../support/helpers/ApiConnection.Helper';
import AuthenticationTypeEntity from '../entities/AuthenticationType.Entity';

export default function getAuthenticationTypes(abortSignal: AbortSignal): Promise<Array<AuthenticationTypeEntity>> {    
    return apiGet<Array<AuthenticationTypeEntity>>('/authentication-type', abortSignal);
}